// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@sc/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.badgesWrapper = {
    ...cartLineSharedStyles.badgesWrapper,
};

quickOrderProductListStyles.cartLineContainer = {
    qty: {
        css: css`
            grid-column: 5 / 6;
            grid-row: 1 / 4;
            ${xScreen("lte", "xs")} {
                grid-column: 1 / 3;
                grid-row: 4 / 5;
                padding-bottom: 5px;
            }
            @media print {
                min-width: 40%;
                min-height: 50px;
                float: left;
            }
        `,
    },
};
quickOrderProductListStyles.noPriceMessage = {
    color: "primary.main",
    lineHeight: "24px",
    size: 16,
    weight: "bold",
};

quickOrderProductListStyles.noPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
            color: "primary.main",
        },
    },
};
